import { useEffect, useState } from "react";
import { useParams } from "react-router";
import _ from "lodash";

import Collapse from "components/Collapse";
import { LinearProgress } from "components/Loading";
import Stack from "components/Stack";
import Text from "components/Text";

import TransactionCollapseTitlesRow from "pages/Deal/FinancingEvents/TransactionCollapse/TransactionCollapseTitlesRow";
import TransactionGeneralInfo from "pages/Deal/FinancingEvents/TransactionGeneralInfo";

import { useTransactions } from "entities/Deal/sdk";

export interface IFinancingEventCollapse {
  financingEventId: number;
  open: boolean;
}

const FinancingEventCollapse = ({
  financingEventId,
  open,
}: IFinancingEventCollapse) => {
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  const params = useParams<{
    dealId: string;
  }>();
  const dealId = Number(params.dealId);
  const {
    data: transactions,
    isValidating,
    isLoading,
  } = useTransactions({
    dealId,
    financingEventId,
    enabled: open || hasBeenOpened,
  });

  useEffect(() => {
    if (open && !_.isEmpty(transactions)) {
      setHasBeenOpened(true);
    }
  }, [open, transactions]);

  if (open && (isValidating || isLoading)) {
    return <LinearProgress sx={{ position: "sticky", left: 0 }} />;
  }

  return (
    <Collapse in={open} timeout="auto">
      <Stack
        display="grid"
        gridTemplateColumns="50px 0.7fr 1fr 1fr 0.7fr 1fr 1fr 100px 35px"
        gap={1}
        alignItems="center"
      >
        {_.isEmpty(transactions) ? (
          <Text variant="text1" sx={{ gridColumn: "1 / -1" }}>
            Currently there are no transactions connected to this event.
          </Text>
        ) : (
          <>
            <TransactionCollapseTitlesRow isHeading={true} />
            {transactions?.map((transaction, index, arr) => (
              <TransactionGeneralInfo
                key={transaction.id}
                transaction={transaction}
                financingEventId={financingEventId}
                isLast={index + 1 === arr.length}
              />
            ))}
          </>
        )}
      </Stack>
    </Collapse>
  );
};
export default FinancingEventCollapse;
